module.exports = __webpack_public_path__ + "static/media/message_received1.b878eb0b.mp3";